import BaseService from './BaseService';

const webApi = '/api/subscription/feed/';

class DataSelectService extends BaseService {
  getTVs(datatype) {
    return this.get(`${webApi}tvlist`, { datatype }).then((res) => res.tvlist);
  }

  getAssetClasses(datatype, tv) {
    // Fetch data and pass the raw response (resp) alongside processed data
    return this.get(`${webApi}assetclasslist`, { datatype, tv }).then((resp) => {
      const assetClasses = resp.assetclasslist;
      const subassetClasses = resp.subassetclasslist;
      const instruments = resp.instrumentlist;
      const miclist = resp.miclist;
      const ordertypelist = resp.ordertypelist;
      return { assetClasses, subassetClasses, instruments , miclist, ordertypelist};
    });
  }

  getSubAssetClasses(datatype, tv, assetclass) {
    return this.get(`${webApi}subassetclasslist`, { datatype, tv, assetclass }).then((resp) => {
      const subassetClasses = resp.subassetclasslist;
      const instruments = resp.instrumentlist;
      const miclist = resp.miclist;
      const ordertypelist = resp.ordertypelist;
      return { subassetClasses, instruments , miclist, ordertypelist };
    });
  }


  getInstruments(datatype, tv, assetclass, subassetclass) {
    return this.get(`${webApi}instrumentlist`, { datatype, tv, assetclass, subassetclass }).then((resp) => {
      const instruments = resp.instrumentlist;
      const miclist = resp.miclist;
      const ordertypelist = resp.ordertypelist;
      return { instruments , miclist, ordertypelist };
    });
  }

  getSegmentMics(datatype, tv, assetclass, subassetclass, instrument) {
    return this.get(`${webApi}miclist`, { datatype, tv, assetclass, subassetclass, instrument }).then((resp) => {
      const miclist = resp.miclist;
      const ordertypelist = resp.ordertypelist;
      return { miclist, ordertypelist };
    });
  }

  getOrderTypes(datatype, tv, assetclass, subassetclass, instrument, instrumentmic) {
    return this.get(`${webApi}ordertypelist`, { datatype, tv, assetclass, subassetclass, instrument, instrumentmic }).then(
      (res) => res.ordertypelist
    );
  }
}

export default DataSelectService;



// WEBPACK FOOTER //
// ./src/services/DataSelectService.js